module.exports = __webpack_public_path__ + "static/img/aboutus_img3.7ea3fe85.jpg";